import React, { Component } from "react";

import "./styles.css";

class ItemCreatorRadio extends Component {
  render() {
    return (
      <input
        type="radio"
        disabled={this.props.readOnly}
        checked={this.props.checkStatus}
        onChange={() => this.props.itemCheckChanger(this.props.itemIndex, true)}
      />
    );
  }
}

export default ItemCreatorRadio;
